import Footer from "components/Footer/Footer"
import Header from "components/Header/Header"
import React from "react"
import { Container } from "theme-ui"

type LayoutProps = {
    children: React.ReactNode
}

const Layout = (props: LayoutProps) => {
    const { children } = props

    return (
        <>
            <Header />
            <Container sx={{ maxWidth: "90%", paddingTop: "50px", marginBottom: '50px' }} bg="muted">
                {children}
            </Container>
            <Footer />
        </>
    )
}

export default Layout